import { IS_FLOATING_ASK_HEIDI_ENABLED } from '@/app-shell/flags/evidence-flags';
import { floatingAskHeidiInputVisibleAtom } from '@/atoms/floatingAskHeidiAtoms';
import { useAtomValue } from 'jotai';

export const FLOATING_INPUT_BOTTOM_OFFSET = 72; // px - floating input (58px tall at bottom-6) + 12-16px gap

/**
 * Hook to determine if the floating Ask Heidi input needs a bottom offset.
 * Used to add padding to content areas so they can scroll past the floating input.
 *
 * @returns {Object} Object containing:
 *   - needsOffset: boolean - Whether padding should be applied
 *   - offsetPx: number - The offset value in pixels (96px)
 */
export function useFloatingAskHeidiOffset() {
  const isVisible = useAtomValue(floatingAskHeidiInputVisibleAtom);
  const isFeatureEnabled = IS_FLOATING_ASK_HEIDI_ENABLED();

  return {
    needsOffset: isFeatureEnabled && isVisible,
    offsetPx: FLOATING_INPUT_BOTTOM_OFFSET,
  };
}
